/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseComponent} from "../../../Components/BaseComponent";
import autobind from "autobind-decorator";

export class BaseFieldViewer extends BaseComponent {
	@autobind
	getFieldDef(key) {
		const {FieldDef, FieldDefs} = this.props;

		if (FieldDefs) {
			const group = FieldDefs.find((x) => x.key === FieldDef.group);

			return group?.value?.find((x) => x.key === key);
		}

		return null;
	}

	@autobind
	getFieldDefCustomData() {
		const {FieldDef} = this.props;

		return FieldDef?.customData || {};
	}

	@autobind
	_render() {
		return null;
	}

	render() {
		return this._render();
	}
}